import * as React from "react";

import { cn } from "@/lib/utils";
import { nativeUxEnabled } from "@/lib/native/nativeUx";

/** Solo app nativa su telefono: i campi di ricerca diventano type="search" (tasto «cancella» di sistema, tasto Invio «Cerca»). Il desktop non cambia. */
const SEARCH_PLACEHOLDER = /(^|\s)(cerca|ricerca|search)/i;
const phoneNative = () => {
  try {
    return nativeUxEnabled() && window.matchMedia("(max-width: 767px)").matches;
  } catch {
    return false;
  }
};

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    const asSearch =
      (type === undefined || type === "text") &&
      typeof props.placeholder === "string" &&
      SEARCH_PLACEHOLDER.test(props.placeholder) &&
      phoneNative();
    return (
      <input
        type={asSearch ? "search" : type}
        enterKeyHint={asSearch ? "search" : undefined}
        className={cn(
          "flex h-[var(--hig-field-h,2.5rem)] w-full rounded-[var(--hig-radius-control,0.375rem)] border border-input bg-background px-3 py-2 text-base max-md:focus-visible:ring-1 max-md:focus-visible:ring-offset-0 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
